// Months are "YYYY-MM" strings and mean the end of that month (PRD §7).

export type Month = string;

export const MONTH_RE = /^\d{4}-(0[1-9]|1[0-2])$/;

const MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function isMonth(s: unknown): s is Month {
	return typeof s === "string" && MONTH_RE.test(s);
}

/** Months since year 0 (Jan of year 0 = 0). */
export function toAbs(m: Month): number {
	const y = Number(m.slice(0, 4));
	const mm = Number(m.slice(5, 7));
	return y * 12 + (mm - 1);
}

export function fromAbs(a: number): Month {
	const y = Math.floor(a / 12);
	const mm = (((a % 12) + 12) % 12) + 1;
	return `${String(y).padStart(4, "0")}-${String(mm).padStart(2, "0")}`;
}

export function addMonths(m: Month, k: number): Month {
	return fromAbs(toAbs(m) + k);
}

/** Whole months from `a` to `b` (positive when `b` is later). */
export function monthDiff(a: Month, b: Month): number {
	return toAbs(b) - toAbs(a);
}

export function compareMonths(a: Month, b: Month): number {
	return toAbs(a) - toAbs(b);
}

export function sortMonths(ms: Month[]): Month[] {
	return [...ms].sort((a, b) => toAbs(a) - toAbs(b));
}

export function yearOf(m: Month): number {
	return Number(m.slice(0, 4));
}

/** "Jun 2027". */
export function fmtMonth(m: Month): string {
	const y = m.slice(0, 4);
	const mm = Number(m.slice(5, 7));
	return `${MONTH_NAMES[mm - 1]} ${Number(y)}`;
}

/** "end of 2028" for December, else "Jun 2027". */
export function fmtByDate(m: Month): string {
	const mm = Number(m.slice(5, 7));
	return mm === 12 ? `end of ${Number(m.slice(0, 4))}` : fmtMonth(m);
}

/** The default last month a node is forecast to: December, nine years after `asOf`'s year. */
export function defaultHorizon(asOf: Month): Month {
	return `${yearOf(asOf) + 9}-12`;
}

/** Latest month allowed as a horizon (PRD §9.1). */
export const MAX_HORIZON: Month = "2100-12";
